import React from "react";

const svgIcons = {
    close: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.9396 12.0008L6.84814 16.0923L7.9088 17.153L12.0003 13.0615L16.0918 17.153L17.1524 16.0923L13.061 12.0008L17.1524 7.90929L16.0918 6.84863L12.0003 10.9401L7.90882 6.84863L6.84816 7.90929L10.9396 12.0008Z"
                fill="#7F7F7F"
            />
        </svg>
    ),

    image: (
        <svg
            width="72"
            height="72"
            viewBox="0 0 72 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M57 16.5H15C12.5147 16.5 10.5 18.5147 10.5 21V36.9297L21.0052 27.5918C21.8315 26.8572 23.0691 26.8319 23.9248 27.532L39.0603 39.9157L43.65 36.4734C44.4843 35.8477 45.6393 35.8773 46.4404 36.5449L61.5 49.0946V21C61.5 18.5147 59.4853 16.5 57 16.5ZM60.3555 53.9985L44.9265 41.141L40.35 44.5734C39.5217 45.1946 38.3765 45.1704 37.5752 44.5148L22.5605 32.2301L10.5 42.9505V51C10.5 53.4853 12.5147 55.5 15 55.5H57C58.3335 55.5 59.5315 54.92 60.3555 53.9985ZM15 12C10.0294 12 6 16.0294 6 21V51C6 55.9706 10.0294 60 15 60H57C61.9706 60 66 55.9706 66 51V21C66 16.0294 61.9706 12 57 12H15ZM42 25.5C42 23.0147 44.0147 21 46.5 21C48.9853 21 51 23.0147 51 25.5C51 27.9853 48.9853 30 46.5 30C44.0147 30 42 27.9853 42 25.5Z"
                fill="#E3E8EC"
            />
        </svg>
    ),

    male: (
        <svg
            width="213"
            height="213"
            viewBox="0 0 213 213"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="106.5" cy="106.5" r="106.5" fill="#DFE1E6" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.1086 176.355C40.3674 168.765 53.8345 166.206 62.1252 164.631C64.999 164.085 67.2508 163.657 68.6981 163.179L68.7519 163.161C74.2425 161.347 80.1003 159.412 80.1003 151.678C80.1003 151.312 80.1005 150.962 80.1007 150.626L80.1007 150.6C80.1049 143.828 80.1056 142.86 78.3315 141.875C74.7677 139.875 72.652 136.788 72.1925 134.392C71.8393 132.569 71.5551 129.409 71.2662 126.195L71.2662 126.195C70.8458 121.52 70.4153 116.732 69.7473 115.787C69.3209 115.175 68.7698 114.988 68.2125 114.8C67.2852 114.486 66.3405 114.166 65.9234 111.872C65.6384 110.344 65.472 108.894 65.3261 107.622L65.3261 107.622L65.326 107.622C65.1213 105.837 64.957 104.405 64.5621 103.604C63.8945 102.225 61.5273 93.3277 63.0014 90.2757C63.7038 88.7843 64.7311 88.5356 65.5441 88.3388C66.2163 88.1761 66.742 88.0488 66.8165 87.284C66.8919 86.5372 66.5753 84.2906 66.1423 81.218L66.1423 81.218C64.9807 72.9759 62.9816 58.7907 65.4639 51.6689C68.6291 42.5667 72.0373 40.4834 75.2971 38.4908C75.6808 38.2563 76.0623 38.023 76.4412 37.7797C77.7749 36.9338 78.9293 35.6 80.2847 34.0338C82.6038 31.3541 85.5115 27.9943 90.9129 25.2355C99.471 20.8731 112.07 23.3992 116.353 25.2355C117.016 25.5212 117.987 25.878 119.163 26.3103C125.584 28.6701 138.128 33.2809 140.224 40.8662C140.229 40.8827 140.309 40.9931 140.448 41.1855L140.448 41.1858C141.327 42.4008 144.57 46.8839 146.224 51.6689C148.703 58.7789 146.714 72.9291 145.555 81.1772C145.12 84.2707 144.802 86.5339 144.88 87.284C144.955 88.0492 145.479 88.1762 146.152 88.3391C146.964 88.5358 147.993 88.7849 148.704 90.2757C150.161 93.3277 147.802 102.225 147.126 103.604C146.735 104.409 146.573 105.85 146.371 107.646L146.371 107.646C146.229 108.912 146.067 110.354 145.791 111.872C145.358 114.164 144.408 114.485 143.482 114.799C142.923 114.988 142.373 115.174 141.95 115.787C141.282 116.732 140.851 121.52 140.431 126.195C140.142 129.409 139.858 132.569 139.504 134.392C139.036 136.788 136.929 139.875 133.365 141.875C131.59 142.856 131.591 143.821 131.596 150.517C131.596 150.886 131.597 151.273 131.597 151.678C131.597 159.403 137.45 161.342 142.918 163.155L142.99 163.179C144.452 163.655 146.763 164.106 149.685 164.677L149.685 164.677C150.94 164.922 152.307 165.189 153.768 165.489C154.136 165.557 154.512 165.639 154.892 165.721L154.893 165.721C155.041 165.753 155.189 165.785 155.337 165.817C156.144 165.981 156.907 166.136 157.757 166.325C157.748 166.33 157.739 166.332 157.731 166.334C157.722 166.336 157.713 166.338 157.705 166.343C165.739 168.16 175.858 171.104 186.429 176.884C166.913 199.029 138.338 213 106.5 213C74.4098 213 45.6342 198.807 26.1086 176.355Z"
                fill="#96A1B5"
            />
        </svg>
    ),

    female: (
        <svg
            width="213"
            height="213"
            viewBox="0 0 213 213"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="106.5" cy="106.5" r="106.5" fill="#DFE1E6" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M38.0356 188.024C44.7968 182.932 53.0463 179.546 60.8094 176.359C72.1281 171.714 82.4131 167.493 85.5445 159.026C85.9825 156.309 85.9825 154.95 85.9825 153.592C67.5871 151.328 54.4475 146.8 54.4475 141.366C59.3711 135.985 59.6409 123.177 59.9588 108.088C60.6306 76.1971 61.5171 34.1172 107.006 30.4287C114.452 30.4287 120.145 32.6927 123.211 35.4096C155.517 34.2273 155.539 73.9453 155.556 105.325C155.565 122.019 155.573 136.353 160.44 140.913V141.366C160.44 146.8 146.863 151.781 128.029 153.592C128.467 155.856 128.467 157.667 128.467 159.026C131.389 167.585 141.621 171.805 152.842 176.433C160.491 179.588 168.599 182.933 175.163 187.97C156.633 203.589 132.699 213 106.568 213C80.4661 213 56.5574 203.61 38.0356 188.024Z"
                fill="#96A1B5"
            />
        </svg>
    ),

    calendar: (
        <svg
            width="18"
            height="20"
            viewBox="0 0 18 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5 3.5V5.5H14V3.5H15C15.8284 3.5 16.5 4.17157 16.5 5V7.01562L1.5 7.01562V5C1.5 4.17157 2.17157 3.5 3 3.5H4V5.5H5.5V3.5L12.5 3.5ZM1.5 8.51562L1.5 17C1.5 17.8284 2.17157 18.5 3 18.5H15C15.8284 18.5 16.5 17.8284 16.5 17V8.51562L1.5 8.51562ZM3 2H4V0H5.5V2L12.5 2V0H14V2H15C16.6569 2 18 3.34315 18 5V17C18 18.6569 16.6569 20 15 20H3C1.34315 20 0 18.6569 0 17V5C0 3.34315 1.34315 2 3 2Z"
                fill="#D2DAE0"
            />
        </svg>
    ),

    plus: (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0)">
                <rect width="30" height="30" rx="4" fill="#F1F3F5" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.25 15.75V21H15.75V15.75H21V14.25H15.75V9H14.25V14.25H9V15.75H14.25Z"
                    fill="#1A1A1A"
                />
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect width="30" height="30" rx="4" fill="white" />
                </clipPath>
            </defs>
        </svg>
    ),

    accepted: (
        <svg
            width="11"
            height="8"
            viewBox="0 0 11 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.6267 1.14067L4.12668 7.53423C3.81353 7.84225 3.3106 7.84017 3 7.52958L0 4.52958L1.13137 3.3982L3.57034 5.83717L9.50467 0L10.6267 1.14067Z"
                fill="white"
            />
        </svg>
    ),

    arrowDown: (
        <svg
            width="10"
            height="16"
            viewBox="0 0 10 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.000107233 10.3736L4.825 15.1985L9.6499 10.3736L8.76456 9.48825L5.45108 12.8017L5.45109 6.82975e-05L4.19902 6.8188e-05L4.19902 12.8018L0.885451 9.48824L0.000107233 10.3736Z"
                fill="#E8333A"
            />
        </svg>
    ),

    arrowUp: (
        <svg
            width="10"
            height="16"
            viewBox="0 0 10 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.6498 4.8249L4.8249 0L0 4.8249L0.885343 5.71024L4.19882 2.39677L4.19882 15.1984H5.45088L5.45088 2.39667L8.76445 5.71024L9.6498 4.8249Z"
                fill="#56A93F"
            />
        </svg>
    ),

    infoIcon: (
        <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.8726 8C15.8726 12.1563 12.6064 15.5 8.60855 15.5C4.61072 15.5 1.34448 12.1563 1.34448 8C1.34448 3.84365 4.61072 0.5 8.60855 0.5C12.6064 0.5 15.8726 3.84365 15.8726 8Z"
                stroke="#366EFF"
            />
            <path
                d="M7.74039 10.1973C7.74951 9.65495 7.81103 9.22656 7.92496 8.91211C8.03889 8.59766 8.27132 8.24902 8.62223 7.86621L9.51773 6.94336C9.90055 6.51042 10.092 6.04557 10.092 5.54883C10.092 5.07031 9.96663 4.69661 9.71598 4.42773C9.46533 4.1543 9.10074 4.01758 8.62223 4.01758C8.15738 4.01758 7.78369 4.14062 7.50113 4.38672C7.21858 4.63281 7.0773 4.96322 7.0773 5.37793H5.81266C5.82177 4.63965 6.08382 4.04492 6.59879 3.59375C7.11832 3.13802 7.7928 2.91016 8.62223 2.91016C9.48355 2.91016 10.1535 3.14258 10.632 3.60742C11.1151 4.06771 11.3566 4.70117 11.3566 5.50781C11.3566 6.30534 10.9875 7.09147 10.2492 7.86621L9.50406 8.60449C9.17138 8.97363 9.00504 9.50456 9.00504 10.1973H7.74039ZM7.6857 12.3643C7.6857 12.1592 7.74723 11.9883 7.87027 11.8516C7.99788 11.7103 8.18473 11.6396 8.43082 11.6396C8.67691 11.6396 8.86376 11.7103 8.99137 11.8516C9.11897 11.9883 9.18277 12.1592 9.18277 12.3643C9.18277 12.5693 9.11897 12.7402 8.99137 12.877C8.86376 13.0091 8.67691 13.0752 8.43082 13.0752C8.18473 13.0752 7.99788 13.0091 7.87027 12.877C7.74723 12.7402 7.6857 12.5693 7.6857 12.3643Z"
                fill="#366EFF"
            />
        </svg>
    ),

    excelIcon: (
        <svg
            width="18"
            height="17"
            viewBox="0 0 18 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.438 14.1251H9.56356C9.52922 14.1251 9.5011 14.0969 9.5011 14.0626V14.0607V14.0585V14.0561V14.0534V14.0506V14.0475V14.0441V14.0406V14.0368V14.0328V14.0285V14.024V14.0193V14.0144V14.0093V14.0039V13.9983V13.9925V13.9865V13.9802V13.9737V13.9671V13.9602V13.953V13.9457V13.9382V13.9304V13.9225V13.9143V13.9059V13.8973V13.8885V13.8795V13.8703V13.8609V13.8512V13.8414V13.8314V13.8212V13.8107V13.8001V13.7893V13.7783V13.767V13.7556V13.744V13.7322V13.7202V13.708V13.6957V13.6831V13.6703V13.6574V13.6443V13.6309V13.6174V13.6037V13.5899V13.5758V13.5616V13.5472V13.5326V13.5178V13.5028V13.4877V13.4724V13.4569V13.4412V13.4254V13.4094V13.3932V13.3769V13.3604V13.3437V13.3268V13.3098V13.2926V13.2753V13.2578V13.2401V13.2222V13.2042V13.1861V13.1678V13.1493V13.1306V13.1118V13.0929V13.0738V13.0545V13.0351V13.0155V12.9958V12.976V12.9559V12.9358V12.9155V12.895V12.8744V12.8536V12.8327V12.8117V12.7905V12.7692V12.7478V12.7262V12.7044V12.6825V12.6605V12.6384V12.6161V12.5937V12.5711V12.5484V12.5256V12.5027V12.4796V12.4564V12.4331V12.4096V12.3861V12.3624V12.3385V12.3146V12.2905V12.2663V12.242V12.2176V12.193V12.1684V12.1436V12.1187V12.0937V12.0685V12.0433V12.018V11.9925V11.9669V11.9412V11.9155V11.8896V11.8636V11.8375V11.8113V11.7849V11.7585V11.732V11.7054V11.6787V11.6519V11.6249V11.5979V11.5708V11.5436V11.5163V11.4889V11.4615V11.4339V11.4062V11.3785V11.3506V11.3227V11.2947V11.2666V11.2384V11.2101V11.1818V11.1533V11.1248V11.0962V11.0676V11.0388V11.01V10.9811V10.9521V10.923V10.8939V10.8647V10.8354V10.8061V10.7766V10.7472V10.7176V10.688V10.6583V10.6285V10.5987V10.5688V10.5389V10.5089V10.4788V10.4487V10.4185V10.3883V10.3579V10.3276V10.2972V10.2667V10.2362V10.2056V10.175V10.1443V10.1136V10.0828V10.052V10.0211V9.99019V9.95923V9.92822V9.89717V9.86608V9.83495V9.80377V9.77256V9.74131V9.71002V9.67869V9.64733V9.61593V9.58449V9.55303V9.52153V9.49V9.45844V9.42685V9.39523V9.36359V9.33191V9.30022V9.26849V9.23675V9.20498V9.17318V9.14137V9.10954V9.07768V9.04581V9.01392V8.98201V8.95009V8.91816V8.88621V8.85424V8.82227V8.79028V8.75829V8.72628V8.69427V8.66225V8.63022V8.59818V8.56615V8.53411V8.50206V8.47001V8.43797V8.40592V8.37387V8.34183V8.30979V8.27775V8.24572V8.21369V8.18167V8.14965V8.11765V8.08565V8.05367V8.02169V7.98973V7.95778V7.92584V7.89392V7.86201V7.83013V7.79825V7.7664V7.73457V7.70275V7.67096V7.63919V7.60744V7.57572V7.54402V7.51235V7.4807V7.44908V7.4175V7.38594V7.35441V7.32291V7.29144V7.26001V7.22861V7.19725V7.16592V7.13463V7.10338V7.07216V7.04099V7.00985V6.97876V6.94771V6.91671V6.88574V6.85483V6.82396V6.79313V6.76236V6.73163V6.70095V6.67032V6.63975V6.60923V6.57876V6.54834V6.51799V6.48768V6.45744V6.42725V6.39712V6.36705V6.33705V6.3071V6.27722V6.2474V6.21764V6.18795V6.15833V6.12878V6.09929V6.06987V6.04052V6.01125V5.98204V5.95291V5.92385V5.89487V5.86596V5.83713V5.80838V5.7797V5.7511V5.72259V5.69415V5.6658V5.63753V5.60935V5.58125V5.55323V5.5253V5.49746V5.46971V5.44205V5.41448V5.38699V5.35961V5.33231V5.30511V5.278V5.25099V5.22408V5.19726V5.17055V5.14393V5.11741V5.091V5.06468V5.03848V5.01237V4.98637V4.96048V4.93469V4.90901V4.88344V4.85798V4.83263V4.80739V4.78227V4.75725V4.73236V4.70757V4.68291V4.65836V4.63393V4.60961V4.58542V4.56135V4.5374V4.51357V4.48987V4.46629V4.44284V4.41951V4.39631V4.37324V4.3503V4.32749V4.30481V4.28226V4.25984V4.23756V4.21541V4.1934V4.17152V4.14978V4.12818V4.10672V4.0854V4.06422V4.04319V4.02229V4.00154V3.98094V3.96048V3.94016V3.92V3.89998V3.88011V3.8604V3.84083V3.82142V3.80216V3.78305V3.7641V3.7453V3.72667V3.70818V3.68986V3.6717V3.6537V3.63586V3.61818V3.60066V3.58331V3.56613V3.54911V3.53225V3.51557V3.49905V3.48271V3.46653V3.45053V3.4347V3.41904V3.40355V3.38824V3.37311V3.35816V3.34338V3.32878V3.31436V3.30013V3.28607V3.2722V3.25851V3.245V3.23168V3.21855V3.2056V3.19284V3.18028V3.1679V3.15571V3.14371V3.13191V3.1203V3.10889V3.09767V3.08664V3.07582V3.06519V3.05476V3.04454V3.03451V3.02469V3.01506V3.00565V2.99643V2.98743V2.97863V2.97003V2.96165V2.95347V2.94551V2.93776V2.93022V2.92289V2.91577V2.90887V2.90219V2.89572V2.88948V2.88344V2.87763V2.87204V2.86668V2.86153V2.85661V2.85191V2.84743V2.84318V2.83916V2.83537V2.83181V2.82847V2.82537V2.82249V2.81985V2.81745V2.81528V2.81334C9.5011 2.779 9.52922 2.75088 9.56356 2.75088H17.438C17.4724 2.75088 17.5005 2.779 17.5005 2.81334V14.0626C17.5005 14.0969 17.4724 14.1251 17.438 14.1251Z"
                fill="white"
                stroke="#DDDFE3"
            />
            <path
                d="M11.8111 5.62655H9.56124C9.25076 5.62655 8.99878 5.37457 8.99878 5.06409C8.99878 4.75361 9.25076 4.50163 9.56124 4.50163H11.8111C12.1216 4.50163 12.3736 4.75361 12.3736 5.06409C12.3736 5.37457 12.1216 5.62655 11.8111 5.62655Z"
                fill="#388E3C"
            />
            <path
                d="M11.8121 7.87544H9.56222C9.25174 7.87544 8.99976 7.62346 8.99976 7.31298C8.99976 7.0025 9.25174 6.75051 9.56222 6.75051H11.8121C12.1226 6.75051 12.3745 7.0025 12.3745 7.31298C12.3745 7.62346 12.1226 7.87544 11.8121 7.87544Z"
                fill="#388E3C"
            />
            <path
                d="M11.8121 10.1254H9.56222C9.25174 10.1254 8.99976 9.87345 8.99976 9.56297C8.99976 9.25249 9.25174 9.00051 9.56222 9.00051H11.8121C12.1226 9.00051 12.3745 9.25249 12.3745 9.56297C12.3745 9.87345 12.1226 10.1254 11.8121 10.1254Z"
                fill="#388E3C"
            />
            <path
                d="M11.8121 12.3751H9.56222C9.25174 12.3751 8.99976 12.1231 8.99976 11.8127C8.99976 11.5022 9.25174 11.2502 9.56222 11.2502H11.8121C12.1226 11.2502 12.3745 11.5022 12.3745 11.8127C12.3745 12.1231 12.1226 12.3751 11.8121 12.3751Z"
                fill="#388E3C"
            />
            <path
                d="M15.1859 5.62545H14.061C13.7505 5.62545 13.4985 5.37346 13.4985 5.06298C13.4985 4.7525 13.7505 4.50052 14.061 4.50052H15.1859C15.4964 4.50052 15.7484 4.7525 15.7484 5.06298C15.7484 5.37346 15.4964 5.62545 15.1859 5.62545Z"
                fill="#388E3C"
            />
            <path
                d="M15.1859 7.87544H14.061C13.7505 7.87544 13.4985 7.62346 13.4985 7.31298C13.4985 7.0025 13.7505 6.75051 14.061 6.75051H15.1859C15.4964 6.75051 15.7484 7.0025 15.7484 7.31298C15.7484 7.62346 15.4964 7.87544 15.1859 7.87544Z"
                fill="#388E3C"
            />
            <path
                d="M15.1859 10.1254H14.061C13.7505 10.1254 13.4985 9.87345 13.4985 9.56297C13.4985 9.25249 13.7505 9.00051 14.061 9.00051H15.1859C15.4964 9.00051 15.7484 9.25249 15.7484 9.56297C15.7484 9.87345 15.4964 10.1254 15.1859 10.1254Z"
                fill="#388E3C"
            />
            <path
                d="M15.1859 12.3751H14.061C13.7505 12.3751 13.4985 12.1231 13.4985 11.8127C13.4985 11.5022 13.7505 11.2502 14.061 11.2502H15.1859C15.4964 11.2502 15.7484 11.5022 15.7484 11.8127C15.7484 12.1231 15.4964 12.3751 15.1859 12.3751Z"
                fill="#388E3C"
            />
            <path
                d="M9.92072 0.130124C9.79248 0.0232565 9.62037 -0.0228655 9.45838 0.0108823L0.45897 1.69827C0.192362 1.74777 0 1.9795 0 2.25061V14.6248C0 14.8948 0.192362 15.1276 0.45897 15.1771L9.45838 16.8645C9.49213 16.8713 9.527 16.8746 9.56187 16.8746C9.69236 16.8746 9.81948 16.8297 9.92072 16.7453C10.0501 16.6384 10.1243 16.4787 10.1243 16.3122V0.563221C10.1243 0.395607 10.0501 0.236992 9.92072 0.130124Z"
                fill="#2E7D32"
            />
            <path
                d="M7.73771 10.3175L5.9592 8.28476L7.75796 5.97191C7.94919 5.72667 7.9042 5.37345 7.66009 5.18221C7.41598 4.99097 7.06275 5.03597 6.87039 5.28008L5.20437 7.42194L3.80047 5.81779C3.59461 5.58156 3.23913 5.56019 3.00739 5.76492C2.77341 5.96966 2.74979 6.32514 2.95452 6.558L4.5013 8.32638L2.93315 10.3422C2.74191 10.5875 2.78691 10.9407 3.03102 11.1319C3.13451 11.2118 3.25713 11.2501 3.37749 11.2501C3.54511 11.2501 3.71047 11.1758 3.82184 11.033L5.25612 9.18807L6.89176 11.0566C7.00313 11.1848 7.15837 11.2501 7.31474 11.2501C7.44635 11.2501 7.57797 11.2039 7.68484 11.1106C7.91882 10.9058 7.94244 10.5504 7.73771 10.3175Z"
                fill="#FAFAFA"
            />
        </svg>
    ),

    badValueSign: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.0281 8C15.0281 12.1563 11.7619 15.5 7.76407 15.5C3.76624 15.5 0.5 12.1563 0.5 8C0.5 3.84365 3.76624 0.5 7.76407 0.5C11.7619 0.5 15.0281 3.84365 15.0281 8Z"
                stroke="#E8333A"
            />
            <path
                d="M8.33146 10.1904H7.18985L7.10099 3.04688H8.42716L8.33146 10.1904ZM7.05313 12.3643C7.05313 12.1592 7.11466 11.9883 7.23771 11.8516C7.36531 11.7103 7.55216 11.6396 7.79825 11.6396C8.04435 11.6396 8.23119 11.7103 8.3588 11.8516C8.4864 11.9883 8.55021 12.1592 8.55021 12.3643C8.55021 12.5693 8.4864 12.7402 8.3588 12.877C8.23119 13.0091 8.04435 13.0752 7.79825 13.0752C7.55216 13.0752 7.36531 13.0091 7.23771 12.877C7.11466 12.7402 7.05313 12.5693 7.05313 12.3643Z"
                fill="#E8333A"
            />
        </svg>
    ),
};

export default svgIcons;
